import { Component, input, output } from "@angular/core";

import { PlantQuickFindComponent } from "../../plant-quick-find/plant-quick-find.component";

@Component({
  selector: "plants-jumbotron",
  imports: [PlantQuickFindComponent],
  templateUrl: "plants-jumbotron.component.html",
  styleUrls: ["plants-jumbotron.component.scss"]
})
export class PlantsJumbotronComponent {
  imageUrl = input.required<string>();
  altImageText = input.required<string>();
  commonName = input.required<string>();
  scientificName = input.required<string>();
  routeToProfile = output<string>();

  onRouteToProfile(): void {
    this.routeToProfile.emit(null);
  }
}
